import React from "react";
import AppHeader from "../../../components/header";
import DigitalService from "./DigitalService";
import LegacyService from "./LegacyService";
import { Stack } from "@mui/material";

const AdditionalServicePage = () => {
  return (
    <AppHeader>
      <Stack gap={4}>
        <LegacyService />
        <DigitalService />
      </Stack>
    </AppHeader>
  );
};

export default AdditionalServicePage;
